"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snippet = void 0;
/* eslint-disable prefer-rest-params */
/* eslint-disable no-template-curly-in-string */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var snippet = function () {
    var org = '${org}';
    var cb = [];
    cb.q = [];
    window.CommandBar = new Proxy(cb, {
        get: function (f, n) {
            if (n in f) {
                return f[n];
            }
            return function () {
                var a = Array.prototype.slice.call(arguments);
                a.unshift(n);
                cb.q.push(a);
            };
        },
    });
    var load = function () {
        var origin = 'https://api.commandbar.com';
        var params = [];
        var lc = localStorage.getItem('commandbar.lc');
        if (lc && lc.includes('local')) {
            // for debugging purposes
            origin = 'http://localhost:8000';
        }
        var src = origin + '/latest/' + org;
        if (lc) {
            params.push('lc=' + lc);
        }
        var v = '${version}';
        if (!!v) {
            params.push('v=' + v);
        }
        src = src + '?' + params.join('&');
        var el = document.createElement('script');
        el.type = 'text/javascript';
        el.async = true;
        el.src = src;
        document.head.appendChild(el);
    };
    if (window.attachEvent) {
        window.attachEvent('onload', load);
    }
    else {
        window.addEventListener('load', load, false);
    }
};
exports.snippet = snippet;
//# sourceMappingURL=snippet.js.map